import {
  Component,
  OnInit,
  Input,
  TemplateRef,
  ViewChild,
} from "@angular/core";
import { AdvtService } from "./../../_services/advt.service";
import { EventEmitter } from "protractor";
import { Router, ActivatedRoute } from "@angular/router";
import { FreeService } from "../../_services/free.service";
import { BsModalRef } from "ngx-bootstrap/modal";
import { BsModalService } from "ngx-bootstrap/modal";
import { environment } from "../../../environments/environment";
import { Subscription } from "rxjs/Subscription";

@Component({
  selector: "app-dashboard-sidemenu",
  templateUrl: "./dashboard-sidemenu.component.html",
  styleUrls: ["./dashboard-sidemenu.component.css"],
  providers: [FreeService, AdvtService],
})
export class DashboardSidemenuComponent implements OnInit {
  @Input() type: string;
  @Input() type2: string;
  listCategories: any;
  public selectedItem = "home";
  public selectedItem1;
  private returnPaypalCapture: Subscription;
  merchant_id;
  entryHref;
  partner_referral_id;
  payerToken_id;
  paypalPayer_id;
  modalRef: BsModalRef;
  loading: Boolean = false;
  @ViewChild("template") template: TemplateRef<any>;
  constructor(
    private advtService: AdvtService,
    private modalService: BsModalService,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {
    this.AddPartnerResponse1();
    this.returnPaypalCapture = this.route.queryParams.subscribe((res) => {      
      if (res.merchantId != null && res.merchantIdInPayPal != null) {
        this.payerToken_id = res.merchantId;
        this.paypalPayer_id = res.merchantIdInPayPal;
      }
    });
    const userInfo = JSON.parse(localStorage.getItem("currentUser"));
    this.merchant_id = userInfo.result.merchant_id;
    this.partner_referral_id = userInfo.result.partner_referral_id;
    this.advtService.getAllCategories().subscribe(
      (data) => {
        this.listCategories = data;
      },
      (error) => {
      }
    );
    if (localStorage.getItem("currentMenu")) {
      this.selectedItem = localStorage.getItem("currentMenu");
    } else {
      localStorage.setItem("currentMenu", "home");
      this.selectedItem = localStorage.getItem("currentMenu");
    }

    if (!this.selectedItem) {
      this.selectedItem = "home";
    }
  }

  AddPartnerResponse1 = async () => {
    const response2 = await fetch(
      `${environment.sandBoxUrll}v2/customer/partner-referrals`,
      {
        method: "POST",
        headers: {
          Authorization:
            "Bearer " + localStorage.getItem("CreatePaypalTokenresp"),
          "Content-Type": "application/json",
        },
        body: `{
          "tracking_id": "test123",
          "operations": [
            {
              "operation": "API_INTEGRATION",
              "api_integration_preference": {
                "rest_api_integration": {
                  "integration_method": "PAYPAL",
                  "integration_type": "THIRD_PARTY",
                  "third_party_details": {
                    "features": [
                      "PAYMENT",
                      "REFUND"
                   ]
                  }
                }
              }
            }
          ],
          "partner_config_override": {
              "return_url": "${environment.bidjonesUrl}dashboard",
              "partner_logo_url": "https://www.seasia.com/webstatic/mktg/logo/pp_cc_mark_111x69.jpg"
          },
          "products": [
            "EXPRESS_CHECKOUT"
          ],
          "legal_consents": [
            {
              "type": "SHARE_DATA_CONSENT",
              "granted": true
            }
          ]
      }`,
      }
    ).then(async (response) => {
      const responseData = await Promise.all([response.json()]);
      this.entryHref = responseData[0].links[1].href;
      return responseData;
    });
    localStorage.setItem("AddPartnerResponse", JSON.stringify(response2));
    localStorage.setItem("AddPartnerResponse", JSON.stringify(response2));
    this.entryHref = response2[0].links[1].href;
  };

  /**
   * Function to open modal
   * @param template
   */

  /**
   *
  //  * @param token token generated during the transaction
   */

  /**
   * function to Disbale Modal
   * @param event
   */

  openModal(template: TemplateRef<any>) {
    this.loading = true;

    this.modalRef = this.modalService.show(
      template,
      Object.assign({}, { class: "gray modal-md" })
    );

    //   this.loading = false;
  }

  openCheckout() {
    this.modalRef.hide();
    this.loading = true;
    setTimeout(() => {
      this.loading = false;
      window.location.href = this.entryHref;
    }, 1000);
    this.loading = false;
  }

  public _hidemodal(event: any) {
    this.modalRef.hide();
  }

  listClick(event, newValue) {
    if (newValue === "post_add") {
      if (
        (this.merchant_id != "undefined" && this.merchant_id == null) ||
        (this.partner_referral_id != "undefined" &&
          this.partner_referral_id == null)
      ) {
        if (this.paypalPayer_id == null && this.payerToken_id == null) {
          this.modalRef = this.modalService.show(
            this.template,
            Object.assign({}, { class: "gray modal-md" })
          );
        } else {
          event.target.classList.remove("class1"); // To Remove
          if (newValue == localStorage.getItem("currentMenu")) {
            localStorage.setItem("currentMenu", "");
            this.selectedItem = "";
          } else {
            localStorage.setItem("currentMenu", newValue);
            this.selectedItem = newValue; // don't forget to update the model here
            // ... do other stuff here ...
          }
        }
      } else {
        event.target.classList.remove("class1");
        if (newValue == localStorage.getItem("currentMenu")) {
          localStorage.setItem("currentMenu", "");
          this.selectedItem = "";
        } else {
          localStorage.setItem("currentMenu", newValue);
          this.selectedItem = newValue; // don't forget to update the model here
          // ... do other stuff here ...
        }
      }
    } else {
      event.target.classList.remove("class1"); // To Remove
      if (newValue == localStorage.getItem("currentMenu")) {
        localStorage.setItem("currentMenu", "");
        this.selectedItem = "";
      } else {
        localStorage.setItem("currentMenu", newValue);
        this.selectedItem = newValue; // don't forget to update the model here
        // ... do other stuff here ...
      }
    }
  }
  dtype(data) {
    this.type = data;
  }

  listClick1(event, newValue) {
    if (newValue == localStorage.getItem("currentMenu")) {
      localStorage.setItem("currentMenu", "");
      this.selectedItem1 = "";
    } else {
      localStorage.setItem("currentMenu", newValue);
      this.selectedItem1 = newValue; // don't forget to update the model here
      // ... do other stuff here ...
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/authorized-data/dashboard-sidemenu/dashboard-sidemenu.component.ts